import {
  axiosClientPortalInstance,
  axiosCompanyPortalInstance,
  axiosInstance,
} from "./";
import { getSessionPortal } from "../../utils/Auth";
import { AUTH_CONTEXT_TYPE } from "../../utils/authPortal";

const UPLOADS_PATH = "/uploads";

/**
 * The presign endpoint exists on every portal with an identical contract, but it
 * only accepts that portal's own token — so it must follow the active session,
 * which is the same thing the request interceptor reads the Bearer token from.
 */
const resolveUploadsInstance = () => {
  switch (getSessionPortal()) {
    case AUTH_CONTEXT_TYPE.COMPANY:
      return axiosCompanyPortalInstance;
    case AUTH_CONTEXT_TYPE.CLIENT:
      return axiosClientPortalInstance;
    default:
      return axiosInstance;
  }
};

/**
 * POST /{portal}/uploads — mint a presigned upload link (valid 1 hour, single use).
 *
 * `downloadLink` is the permanent object URL and the value to store; it can never
 * be derived on the client because the backend inserts a random segment into the
 * key, so always read it from the response.
 *
 * `handlerEnabled: false` keeps the interceptor from driving the global loader —
 * otherwise it would clear the loader as soon as this call resolves, while the
 * much longer PUT of the file bytes is still running.
 */
export const generateUploadLink = async ({ fileName, folderName }) => {
  const payload = { file_name: fileName };
  if (folderName) {
    payload.folder_name = folderName;
  }
  const response = await resolveUploadsInstance().post(UPLOADS_PATH, payload, {
    handlerEnabled: false,
  });
  const data = response?.data?.data ?? {};
  return { uploadLink: data.upload_link, downloadLink: data.download_link };
};
